module.exports = __webpack_public_path__ + "static/img/srsc_logo.3042a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/srsc_logo.png
// module id = hSjh
// module chunks = 190